import { combineReducers } from "redux";
import user from "./userReducer";
import profile from "./profileReducer";
import recipes from "./recipesReducer";
import apiCallsInProgress from "./apiStatusReducer";
import viewingUser from "./viewingUserReducer";
import reganAndRaeFavorites from "./reganAndRaeFavoritesReducer";

const rootReducer = combineReducers({
  user,
  profile,
  recipes,
  apiCallsInProgress,
  viewingUser,
  reganAndRaeFavorites,
});

export default rootReducer;
